// Keep secondary card images inert until the customer approaches that image.
const terrainPrepareCard = (card, index) => {
  const first = card.querySelector(".card__main-image[data-media-id]");
  if (!first) return [];
  const templates = [
    ...card.querySelectorAll("template[data-terrain-card-media]"),
  ];
  const ids = [
    first.dataset.mediaId,
    ...templates.map((t) => t.dataset.terrainCardMedia),
  ];
  for (let i = 0; i < templates.length; i++) {
    const template = templates[i],
      slot = i + 1,
      near = [
        index,
        (index + 1) % ids.length,
        (index - 1 + ids.length) % ids.length,
      ].includes(slot);
    const mounted =
      template.nextElementSibling?.dataset.mediaId === ids[slot]
        ? template.nextElementSibling
        : null;
    if (near && !mounted && template.content.firstElementChild)
      template.after(template.content.firstElementChild);
    if (!near && mounted) template.content.append(mounted);
  }
  card.images = card.querySelectorAll(".card__main-image");
  return ids;
};
document.addEventListener(
  "change",
  (event) => {
    if (!event.target.matches("product-card .opt-btn")) return;
    const card = event.target.closest("product-card"),
      templates = [
        ...card.querySelectorAll("template[data-terrain-card-media]"),
      ];
    const index =
      templates.findIndex(
        (t) => t.dataset.terrainCardMedia === event.target.dataset.mediaId,
      ) + 1;
    terrainPrepareCard(card, index);
    card.dataset.terrainImageIndex = index;
  },
  true,
);

/* Shared stable size ranking; server equivalent: snippets/terrain-size-order.liquid. */
(() => {
  function key(value) {
    const text = String(value).trim().toUpperCase().replaceAll(",", ".");
    const head = text.split(/[ (]/)[0];
    const basic = ["XXS", "XS", "S", "M", "L", "XL"].indexOf(head);
    if (basic >= 0) return [0, basic * 1000];
    if (/^X{2,}L$/.test(head)) return [0, (head.length + 3) * 1000];
    if (/^([2-9]|[1-9]\d+)XL$/.test(head))
      return [0, (parseInt(head, 10) + 4) * 1000];
    const match = text.match(/\d[\d./]*/);
    if (match) {
      const [a, b] = match[0].split("/").map(Number);
      if (b === 0) return [2, 0];
      const tail = text.slice(match.index + match[0].length);
      const mixed =
        b === undefined && tail.match(/^\s+(\d+)\/(\d+)(?:["″\s]|$)/);
      const fraction =
        mixed && Number(mixed[2]) > 0 ? Number(mixed[1]) / Number(mixed[2]) : 0;
      return [1, Math.round((b === undefined ? a + fraction : a / b) * 1000)];
    }
    return [2, 0];
  }
  const compare = (a, b) => {
    const x = key(a),
      y = key(b);
    return x[0] - y[0] || x[1] - y[1];
  };
  window.terrainSizeOrder = {
    key,
    compare,
    sort: (values) =>
      values
        .map((value, index) => ({ value, index }))
        .sort((a, b) => compare(a.value, b.value) || a.index - b.index)
        .map((x) => x.value),
  };
  function init() {
    document.querySelectorAll("[data-terrain-size-filter]").forEach((list) => {
      const items = [...list.children];
      const sorted = [...items].sort((a, b) =>
        compare(
          a.querySelector("input")?.value || a.textContent,
          b.querySelector("input")?.value || b.textContent,
        ),
      );
      if (sorted.some((item, i) => item !== items[i])) list.append(...sorted);
    });
  }
  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("on:facet-filters:updated", init);
  document.addEventListener("shopify:section:load", init);
})();

/* Only visible media enters the network queue; works with section rendering too. */
(() => {
  const reveal = (img) => {
    const picture = img.closest("picture");
    (picture
      ? picture.querySelectorAll("[data-terrain-srcset]")
      : [img]
    ).forEach((node) => {
      if (node.dataset.terrainSrcset) {
        node.srcset = node.dataset.terrainSrcset;
        delete node.dataset.terrainSrcset;
      }
    });
    if (img.dataset.terrainSrc) {
      img.src = img.dataset.terrainSrc;
      delete img.dataset.terrainSrc;
    }
  };
  const observer =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                reveal(entry.target);
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: "200px" },
        )
      : null;
  const watch = (root) =>
    root
      .querySelectorAll("img[data-terrain-src]")
      .forEach((img) => (observer ? observer.observe(img) : reveal(img)));
  watch(document);
  new MutationObserver((records) =>
    records.forEach((record) =>
      record.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches("img[data-terrain-src]")) {
          if (observer) observer.observe(node);
          else reveal(node);
        }
        watch(node);
      }),
    ),
  ).observe(document.body, { childList: true, subtree: true });
})();

(() => {
  const q = (s, r = document) => r.querySelector(s);
  const init = () => {
    const toggle = q(".terrain-announcement-toggle"),
      panel = q("#TerrainServicePanel");
    if (toggle && panel && !toggle.dataset.ready) {
      toggle.dataset.ready = "true";
      toggle.addEventListener("click", () => {
        if (matchMedia("(max-width:768px)").matches) {
          let sheet = q("#TerrainActionsDialog");
          if (!sheet) {
            sheet = document.createElement("dialog");
            sheet.id = "TerrainActionsDialog";
            sheet.className = "terrain-actions-dialog";
            sheet.setAttribute("aria-labelledby", "TerrainActionsTitle");
            sheet.innerHTML =
              '<header><h2 id="TerrainActionsTitle">Aktionen</h2><button type="button" aria-label="Aktionen schließen">×</button></header>';
            const body = document.createElement("div");
            body.className = "terrain-actions-content";
            [...panel.children].forEach((e) => body.append(e.cloneNode(true)));
            sheet.append(body);
            document.body.append(sheet);
            sheet.querySelector("button").onclick = () => sheet.close();
            sheet.addEventListener("click", (e) => {
              if (e.target === sheet) {
                const box = sheet.getBoundingClientRect();
                if (
                  e.clientY < box.top ||
                  e.clientX < box.left ||
                  e.clientX > box.right
                )
                  sheet.close();
              }
            });
            sheet.addEventListener("close", () => {
              toggle.setAttribute("aria-expanded", "false");
              document.dispatchEvent(new Event("terrain:surfaces-changed"));
            });
            document.dispatchEvent(new Event("terrain:surfaces-changed"));
          }
          sheet.showModal();
          toggle.setAttribute("aria-expanded", "true");
          return;
        }
        panel.hidden = !panel.hidden;
        toggle.setAttribute("aria-expanded", String(!panel.hidden));
      });
    }
    document.querySelectorAll("[data-terrain-video]").forEach((video) => {
      if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      if (video.dataset.terrainQueued) return;
      video.dataset.terrainQueued = "true";
      const start = () => {
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          video.src = video.dataset.terrainVideo;
          video.addEventListener("playing", () => video.classList.add("is-playing"), {once:true});
          video.play().catch(() => {});
        }, {rootMargin:"200px"});
        observer.observe(video);
      };
      if (document.readyState === "complete") start();
      else window.addEventListener("load", start, {once:true});
    });
  };
  document.addEventListener("click", async (event) => {
    const size = event.target.closest("[data-terrain-add-size]");
    if (size) {
      const form = size.closest("form");
      form.elements.id.value = size.dataset.terrainAddSize;
      form.requestSubmit();
      return;
    }
  });
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
  document.addEventListener("shopify:section:load", init);
})();

document.addEventListener("on:variant:change", (event) => {
  const v = event.detail?.variant;
  if (!v || v.available) return;
  requestAnimationFrame(() => {
    const dialog = document.getElementById("terrain-stock-alert");
    if (!dialog) return;
    const title = dialog.querySelector("[data-terrain-stock-heading]");
    if (title)
      title.textContent = `Bescheid geben, wenn ${v.title} wieder da ist`;
    const id = dialog.querySelector('[name="contact[Variant ID]"]');
    const name = dialog.querySelector('[name="contact[Variant Title]"]');
    if (id) id.value = v.id;
    if (name) name.value = v.title;
    dialog.open(event.target);
  });
});
document.addEventListener("click", async (event) => {
  const unit = event.target.closest("[data-terrain-unit]");
  if (unit) {
    const dialog = unit.closest("modal-dialog");
    dialog
      .querySelectorAll("[data-terrain-unit]")
      .forEach((b) => b.setAttribute("aria-pressed", String(b === unit)));
    dialog.querySelectorAll("td").forEach((cell) => {
      cell.dataset.cm ??= cell.textContent;
      if (unit.dataset.terrainUnit === "cm") cell.textContent = cell.dataset.cm;
      else
        cell.textContent = cell.dataset.cm.replace(/\d+(?:[.,]\d+)?/g, (n) =>
          (Number(n.replace(",", ".")) / 2.54).toFixed(1).replace(".", ","),
        );
    });
    return;
  }
  const tab = event.target.closest('[data-terrain-tabs] [role="tab"]');
  if (!tab) return;
  const root = tab.closest("[data-terrain-tabs]");
  root.querySelectorAll('[role="tab"]').forEach((b) => {
    b.setAttribute("aria-selected", String(b === tab));
    b.tabIndex = b === tab ? 0 : -1;
  });
  root
    .querySelectorAll('[role="tabpanel"]')
    .forEach((p) => (p.hidden = p.id !== tab.getAttribute("aria-controls")));
  const panel = document.getElementById(tab.getAttribute("aria-controls"));
  if (!panel.dataset.terrainTabUrl || panel.dataset.loaded) return;
  try {
    panel.setAttribute("aria-busy", "true");
    const response = await fetch(panel.dataset.terrainTabUrl);
    if (!response.ok) throw Error(response.status);
    const doc = new DOMParser().parseFromString(
      await response.text(),
      "text/html",
    );
    const grid = doc.querySelector("[data-terrain-tab-results]");
    if (!grid) throw Error("Missing products");
    panel.replaceChildren(grid);
    panel.dataset.loaded = "true";
  } catch {
    panel.textContent =
      ((window.terrainI18n||{}).products_load_error||"Die Produkte konnten nicht geladen werden. Bitte versuche es erneut.");
  } finally {
    panel.removeAttribute("aria-busy");
  }
});
document.addEventListener("keydown", (event) => {
  const tab = event.target.closest('[data-terrain-tabs] [role="tab"]');
  if (!tab || !["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key))
    return;
  event.preventDefault();
  const tabs = [
    ...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'),
  ];
  const i =
    event.key === "Home"
      ? 0
      : event.key === "End"
        ? tabs.length - 1
        : (tabs.indexOf(tab) +
            (event.key === "ArrowRight" ? 1 : -1) +
            tabs.length) %
          tabs.length;
  tabs[i].focus();
  tabs[i].click();
});

if (new URLSearchParams(location.search).has("contact_posted")) {
  customElements.whenDefined("modal-dialog").then(() => {
    const d = document.getElementById("terrain-stock-alert");
    if (d?.querySelector(".bg-success-bg")) d.open();
  });
}

document.addEventListener("submit", (e) => {
  if (e.target.closest("#terrain-stock-alert"))
    sessionStorage.setItem(
      "terrain-stock-size",
      e.target.querySelector('[name="contact[Variant Title]"]')?.value || "",
    );
});
const stockSuccess = document.querySelector("[data-terrain-stock-success]");
if (stockSuccess) {
  const size = sessionStorage.getItem("terrain-stock-size");
  if (size)
    stockSuccess.textContent = ((window.terrainI18n||{}).stock_notify_size||'Wir melden uns, sobald Größe [size] wieder da ist.').replace('[size]', size);
  sessionStorage.removeItem("terrain-stock-size");
}

(() => {
  const imagesOf = (card) => [
    ...card.querySelectorAll(".card__main-image[data-media-id]"),
  ];
  const preload = (card, index) => {
    const images = imagesOf(card);
    for (const offset of [-1, 0, 1]) {
      const image = images[(index + offset + images.length) % images.length];
      if (image) {
        image.loading = "eager";
        if (image.dataset.src) image.src = image.dataset.src;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      }
    }
  };
  const show = (card, delta) => {
    const count =
      1 + card.querySelectorAll("template[data-terrain-card-media]").length;
    if (count < 2) return;
    const index =
      (Number(card.dataset.terrainImageIndex || 0) + delta + count) % count;
    const ids = terrainPrepareCard(card, index);
    card.dataset.terrainImageIndex = index;
    preload(card, index);
    imagesOf(card).forEach(
      (image) => (image.hidden = image.dataset.mediaId !== ids[index]),
    );
    card.classList.add("terrain-browsing");
    card.style.setProperty(
      "--terrain-picture-progress",
      `${((index + 1) / count) * 100}%`,
    );
  };
  document.addEventListener("pointerover", (e) => {
    const card = e.target.closest("product-card");
    if (card && !card.contains(e.relatedTarget)) {
      terrainPrepareCard(card, Number(card.dataset.terrainImageIndex || 0));
      preload(
        card,
        Math.max(
          0,
          imagesOf(card).findIndex((i) => !i.hidden),
        ),
      );
    }
  });
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-terrain-picture]");
    if (b) {
      e.preventDefault();
      show(b.closest("product-card"), Number(b.dataset.terrainPicture));
    }
  });
  let start;
  document.addEventListener(
    "mousedown",
    (e) => {
      if (
        !matchMedia("(max-width:768px)").matches &&
        e.target.closest("product-card .card__media>.media")
      )
        e.stopPropagation();
    },
    true,
  );
  document.addEventListener("pointerdown", (e) => {
    const media = e.target.closest("product-card .card__media>.media");
    if (
      !media ||
      e.button !== 0 ||
      (matchMedia("(max-width:768px)").matches &&
        media.closest("carousel-slider"))
    )
      return;
    start = {
      card: media.closest("product-card"),
      media,
      x: e.clientX,
      y: e.clientY,
      id: e.pointerId,
      steps: 0,
    };
  });
  document.addEventListener("dragstart", (e) => {
    if (e.target.closest("product-card .card__media>.media"))
      e.preventDefault();
  });
  document.addEventListener(
    "pointermove",
    (e) => {
      if (!start || e.pointerId !== start.id) return;
      const dx = e.clientX - start.x,
        dy = e.clientY - start.y;
      if (Math.abs(dx) >= 60 && Math.abs(dx) > Math.abs(dy)) {
        start.dragged = true;
        start.media.setPointerCapture?.(e.pointerId);
        const steps = Math.trunc(dx / 60);
        while (start.steps !== steps) {
          const direction = Math.sign(steps - start.steps);
          show(start.card, -direction);
          start.steps += direction;
        }
        start.card.dataset.swiped = "true";
        e.preventDefault();
      }
    },
    { passive: false },
  );
  document.addEventListener("pointerup", (e) => {
    if (!start || e.pointerId !== start.id) return;
    const s = start;
    start = null;
    const dx = e.clientX - s.x,
      dy = e.clientY - s.y;
    if (s.dragged || (Math.abs(dx) >= 60 && Math.abs(dx) > Math.abs(dy))) {
      if (!s.dragged) show(s.card, dx < 0 ? 1 : -1);
      s.card.dataset.swiped = "true";
      setTimeout(() => delete s.card.dataset.swiped, 400);
    }
  });
  document.addEventListener("pointercancel", () => (start = null));
  document.addEventListener(
    "click",
    (e) => {
      if (e.target.closest("product-card[data-swiped]")) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true,
  );
  document.addEventListener("change", (e) => {
    if (e.target.matches(".card__swatches input")) {
      const card = e.target.closest("product-card");
      requestAnimationFrame(() => {
        card.classList.add("terrain-browsing");
        const images = imagesOf(card),
          index = Math.max(
            0,
            images.findIndex((i) => !i.hidden),
          );
        preload(card, index);
        card.style.setProperty(
          "--terrain-picture-progress",
          `${((index + 1) / images.length) * 100}%`,
        );
      });
    }
  });
})();

(() => {
  const sync = () => {
    document
      .querySelectorAll("[data-panel-clear]")
      .forEach((b) => (b.hidden = !document.querySelector(".active-filter")));
  };
  document.addEventListener("on:facet-filters:updated", sync);
  document.addEventListener("click", (e) => {
    if (e.target.matches("[data-panel-clear]"))
      document.querySelector(".facets .js-clear-all")?.click();
  });
  sync();
})();
(() => {
  const key = "terrain-wishlist",
    dialog = document.getElementById("terrain-wishlist");
  let items = [];
  try {
    items = JSON.parse(localStorage.getItem(key) || "[]");
    if (!Array.isArray(items)) items = [];
  } catch {}
  const sync = () => {
    document
      .querySelectorAll("product-card:not([data-picture-ready])")
      .forEach((card) => {
        card.dataset.pictureReady = "true";
        const count =
          1 + card.querySelectorAll("template[data-terrain-card-media]").length;
        if (count)
          card.style.setProperty(
            "--terrain-picture-progress",
            `${100 / count}%`,
          );
      });
    document.querySelectorAll("[data-wish-count]").forEach((e) => {
      if (e.textContent !== String(items.length)) e.textContent = items.length;
      e.hidden = !items.length;
    });
    document
      .querySelectorAll("[data-wish-url]")
      .forEach((e) =>
        e.setAttribute(
          "aria-pressed",
          String(items.includes(e.dataset.wishUrl)),
        ),
      );
  };
  const save = () => {
    try {
      localStorage.setItem(key, JSON.stringify(items));
    } catch {}
    sync();
  };
  const money = (n) =>
    new Intl.NumberFormat(document.documentElement.lang || "de-DE", {
      style: "currency",
      currency: window.Shopify?.currency?.active || "EUR",
    }).format(n / 100);
  const render = async () => {
    const root = dialog.querySelector("[data-wish-items]");
    root.replaceChildren();
    if (!items.length) {
      root.textContent = (window.terrainI18n||{}).wishlist_empty||"Deine Merkliste ist noch leer.";
      return;
    }
    for (const url of [...items]) {
      const article = document.createElement("article");
      root.append(article);
      try {
        // Grund-Handle über die aktuelle Sprache laden: Shopify leitet auf den übersetzten Handle um (Query bleibt erhalten)
        const handle = url.split("?")[0].replace(/\/$/, "").split("/").pop();
        const r = await fetch((window.Shopify?.routes?.root || "/") + "products/" + encodeURIComponent(handle) + "?view=wish");
        if (!r.ok) throw Error();
        const p = await r.json();
        const img = document.createElement("img");
        img.src = p.featured_image;
        img.alt = p.title;
        article.append(img);
        const body = document.createElement("div");
        article.append(body);
        const link = document.createElement("a");
        link.href = p.url;
        link.textContent = p.title;
        body.append(link);
        const price = document.createElement("p");
        body.append(price);
        const select = document.createElement("select");
        select.setAttribute("aria-label", ((window.terrainI18n||{}).variant_for||"Variante für [title]").replace("[title]", p.title));
        p.variants.forEach((v) => {
          const o = new Option(
            v.title + (v.available ? "" : " – " + ((window.terrainI18n||{}).sold_out||"Ausverkauft")),
            v.id,
          );
          o.disabled = !v.available;
          select.add(o);
        });
        select.value =
          p.variants.find((v) => v.available)?.id || p.variants[0].id;
        const update = () =>
          (price.textContent =
            money(
              p.variants.find((v) => String(v.id) === select.value)?.price ||
                p.price,
            ) +
            (document.documentElement.dataset.priceStar === "true" ? "*" : ""));
        select.onchange = update;
        update();
        if (p.variants.length > 1) body.append(select);
        const add = document.createElement("button");
        add.className = "btn btn--primary";
        add.textContent = (window.terrainI18n||{}).add_to_cart||"In den Warenkorb";
        add.disabled = !p.available;
        add.onclick = async () => {
          add.disabled = true;
          try {
            await window.terrainAdd(select.value);
            dialog.querySelector("[data-wish-status]").textContent =
              ((window.terrainI18n||{}).added_to_cart||'[title] wurde zum Warenkorb hinzugefügt.').replace('[title]', p.title);
          } catch (e) {
            dialog.querySelector("[data-wish-status]").textContent = e.message;
          } finally {
            add.disabled = !p.available;
          }
        };
        body.append(add);
      } catch {
        article.textContent = (window.terrainI18n||{}).product_load_error||"Produkt konnte nicht geladen werden.";
      }
      const remove = document.createElement("button");
      remove.textContent = (window.terrainI18n||{}).wishlist_remove_item||"Entfernen";
      remove.onclick = () => {
        items = items.filter((i) => i !== url);
        save();
        render();
      };
      article.lastElementChild?.append(remove) || article.append(remove);
    }
  };
  window.terrainAdd = async (id) => {
    const drawer = document.querySelector("cart-drawer"),
      payload = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer) {
      payload.sections = drawer.getSectionsToRender().map((s) => s.section);
      payload.sections_url = location.pathname;
    }
    const response = await fetch(
      (window.Shopify?.routes?.root || "/") + "cart/add.js",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (!response.ok)
      throw Error(data.description || "Hinzufügen fehlgeschlagen");
    const cart = await fetch(
      (window.Shopify?.routes?.root || "/") + "cart.js",
    ).then((r) => r.json());
    document.dispatchEvent(
      new CustomEvent("on:cart:change", { bubbles: true, detail: { cart } }),
    );
    if (drawer) {
      if (dialog.open) dialog.close();
      await drawer.renderContents(data, true);
    }
    return cart;
  };
  document.addEventListener("click", (e) => {
    const heart = e.target.closest("[data-wish-url]");
    if (heart) {
      const url = heart.dataset.wishUrl;
      const adding = !items.includes(url);
      items = adding ? [...items, url] : items.filter((i) => i !== url);
      save();
      heart.setAttribute(
        "aria-label",
        adding ? ((window.terrainI18n||{}).wishlist_remove||"Von der Merkliste entfernen") : ((window.terrainI18n||{}).wishlist_add||"Auf die Merkliste"),
      );
      if (matchMedia("(max-width:768px)").matches) {
        let status = document.querySelector("[data-terrain-wish-feedback]");
        if (!status) {
          status = document.createElement("div");
          status.className = "terrain-wish-feedback";
          status.dataset.terrainWishFeedback = "";
          status.setAttribute("role", "status");
          document.body.append(status);
        }
        clearTimeout(status.hideTimer);
        status.hidden = false;
        status.textContent = adding
          ? ((window.terrainI18n||{}).wishlist_added||"Zur Merkliste hinzugefügt")
          : ((window.terrainI18n||{}).wishlist_removed||"Aus der Merkliste entfernt");
        status.hideTimer = setTimeout(() => {
          status.hidden = true;
        }, 3000);
      }
    }
    if (e.target.closest("[data-terrain-open-wishlist]")) {
      dialog.showModal();
      render();
    }
    if (e.target.closest("[data-wish-close]")) dialog.close();
  });
  dialog?.addEventListener("click", (e) => {
    if (e.target === dialog && e.clientX < dialog.getBoundingClientRect().left)
      dialog.close();
  });
  new MutationObserver(sync).observe(document.body, {
    childList: true,
    subtree: true,
  });
  sync();
})();
(() => {
  const init = () =>
    document
      .querySelectorAll(
        ".t-slider,.t-cl carousel-slider,.cc-recently-viewed carousel-slider,.quick-links--carousel,.terrain-seasonal--reading",
      )
      .forEach((root) => {
        if (root.dataset.r14) return;
        const slider = root.querySelector(
          ".slider,.quick-links__list,.terrain-seasonal__grid",
        );
        if (!slider) return;
        root.dataset.r14 = "true";
        let progress;
        {
          progress = document.createElement("div");
          progress.className =
            "terrain-slider-progress";
          progress.innerHTML = "<span></span>";
          progress.setAttribute("aria-hidden", "true");
          if (root.matches(".terrain-seasonal--reading"))
            slider.insertAdjacentElement("afterend", progress);
          else root.append(progress);
        }
        const sync = () => {
          const max = slider.scrollWidth - slider.clientWidth;
          if (progress)
            progress.hidden =
              max < 2 ||
              ((root.matches(
                ".quick-links--carousel,.terrain-seasonal--reading",
              ) ||
                root.closest(".t-cl")) &&
                !matchMedia("(max-width:768px)").matches);
          if (progress)
            progress.style.setProperty(
              "--terrain-scroll",
              `${Math.min(100, ((slider.scrollLeft + slider.clientWidth) / Math.max(1, slider.scrollWidth)) * 100)}%`,
            );
          const media = root.querySelector(".card__media");
          if (media)
            root.style.setProperty(
              "--terrain-arrow-y",
              `${media.getBoundingClientRect().height / 2}px`,
            );
        };
        slider.addEventListener("scroll", sync, { passive: true });
        new ResizeObserver(sync).observe(slider);
        new MutationObserver(sync).observe(root, {
          attributes: true,
          attributeFilter: ["disabled", "inactive"],
          subtree: true,
        });
        window.addEventListener("load", sync);
        sync();
      });
  new MutationObserver(() => queueMicrotask(init)).observe(document.body, {
    childList: true,
    subtree: true,
  });
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("on:facet-filters:updated", init);
  init();
  document.addEventListener("dragstart", (e) => {
    if (e.target.closest("carousel-slider")) e.preventDefault();
  });
  document.addEventListener("click", async (e) => {
    const b = e.target.closest("[data-terrain-direct]");
    if (!b) return;
    const original = b.innerHTML;
    b.disabled = true;
    b.setAttribute("aria-busy", "true");
    b.textContent = "…";
    try {
      await window.terrainAdd(b.dataset.terrainDirect);
      b.textContent = "✓";
    } catch (err) {
      b.textContent = "!";
      b.setAttribute("aria-label", err.message);
    } finally {
      b.removeAttribute("aria-busy");
      setTimeout(() => {
        b.disabled = false;
        b.innerHTML = original;
      }, 1600);
    }
  });
})();
// Reopen a selected unavailable size without replacing or hiding any options.
document.addEventListener("click", (e) => {
  const label = e.target.closest("variant-picker .opt-label");
  if (!label || label.matches("[data-swatch]")) return;
  const input = document.getElementById(label.htmlFor),
    picker = label.closest("variant-picker");
  if (input?.checked && input.classList.contains("is-unavailable")) {
    e.preventDefault();
    picker.announceChange?.();
  }
});
(() => {
  const cache = new Map();
  const sync = async () => {
    const hint = document.querySelector("[data-terrain-other-color]"),
      picker = document.querySelector(".pdp variant-picker");
    if (!hint || !picker) return;
    hint.hidden = true;
    try {
      const url = hint.dataset.productUrl;
      if (!cache.has(url))
        cache.set(
          url,
          fetch(url + ".js").then((r) => r.json()),
        );
      const p = await cache.get(url);
      const ci = p.options.findIndex((o) =>
        /farbe|color|colour/i.test(o.name || o),
      );
      if (ci < 0) return;
      const selected = picker
        .querySelectorAll("fieldset")
        [ci]?.querySelector("input:checked")?.value;
      if (
        !selected ||
        p.variants.some((v) => v.options[ci] === selected && v.available)
      )
        return;
      const other = p.variants.find((v) => v.available);
      if (!other) return;
      hint.textContent = ((window.terrainI18n||{}).other_colors||"In anderen Farben verfügbar:") + " ";
      const a = document.createElement("a");
      a.href = url + "?variant=" + other.id;
      a.textContent = other.options[ci];
      a.onclick = (e) => {
        const input = [
          ...picker.querySelectorAll("fieldset")[ci].querySelectorAll("input"),
        ].find((i) => i.value === other.options[ci]);
        if (input) {
          e.preventDefault();
          input.click();
        }
      };
      hint.append(a);
      hint.hidden = false;
    } catch {}
  };
  document.addEventListener("on:variant:change", sync);
  sync();
})();
(() => {
  const host = document.querySelector("[data-review-distribution]"),
    widget = document.querySelector("#terrain-reviews .jdgm-review-widget");
  if (!host || !widget) return;
  let signature = "";
  const update = () => {
    const header = widget.querySelector(".jm-review-widget__header");
    const totalEl =
      header &&
      [...header.querySelectorAll("*")].find((e) =>
        /^\d+\s+Bewertung(en)?$/.test(e.textContent.trim()),
      );
    const total = Number(totalEl?.textContent.trim().match(/^\d+/)?.[0]);
    const reviews = [...widget.querySelectorAll(".jm-review-item")];
    const scores = reviews.map((r) =>
      Number(
        r
          .querySelector(".jm-star-rating")
          ?.getAttribute("aria-label")
          ?.match(/^[1-5]/)?.[0],
      ),
    );
    if (!total || scores.length !== total || scores.some((s) => !s)) {
      host.hidden = true;
      return;
    }
    const next = scores.join(",");
    host.hidden = false;
    if (next === signature) return;
    signature = next;
    const table = document.createElement("table");
    table.className = "w-full";
    const caption = document.createElement("caption");
    caption.textContent = "Bewertungsverteilung";
    table.append(caption);
    const body = document.createElement("tbody");
    for (let star = 5; star > 0; star--) {
      const count = scores.filter((s) => s === star).length,
        row = document.createElement("tr"),
        label = document.createElement("th"),
        bar = document.createElement("td"),
        number = document.createElement("td"),
        meter = document.createElement("meter");
      label.scope = "row";
      label.textContent = star === 1 ? "1 Stern" : star + " Sterne";
      meter.min = 0;
      meter.max = total;
      meter.value = count;
      meter.className = "w-full";
      meter.setAttribute(
        "aria-label",
        `${count} von ${total} Bewertungen mit ${star} ${star === 1 ? "Stern" : "Sternen"}`,
      );
      bar.append(meter);
      number.textContent = count;
      row.append(label, bar, number);
      body.append(row);
    }
    table.append(body);
    host.replaceChildren(table);
  };
  new MutationObserver(update).observe(widget, {
    childList: true,
    subtree: true,
    characterData: true,
  });
  update();
})();


document.querySelectorAll(".tb-check").forEach((e) => {
  const m = matchMedia("(max-width:768px)");
  const update = () => (e.open = !m.matches);
  update();
  m.addEventListener("change", update);
});

document.addEventListener("click", (e) => {
  const b = e.target.closest("[data-terrain-read-more]");
  if (!b) return;
  const preview = b.closest(".terrain-description-preview"),
    details = preview.nextElementSibling?.querySelector(".disclosure__content"),
    content = preview.querySelector("[data-mobile-description]");
  if (details && content) {
    const open = b.getAttribute("aria-expanded") !== "true";
    if (!content.innerHTML) content.innerHTML = details.innerHTML;
    content.hidden = !open;
    preview.querySelector("p").hidden = open;
    b.setAttribute("aria-expanded", String(open));
    b.textContent = open ? "Weniger lesen" : "Mehr lesen";
  }
});

// Click locks zoom until the next click or leaving the whole image container.
(() => {
  let last = 0;
  const selector = '.pdp .media-viewer__item[data-media-type="image"] .media';
  document.addEventListener("pointerup", (e) => {
    const media = e.target.closest(selector);
    if (!media || e.target.closest("button,a")) return;
    const img = media.querySelector(".product-image");
    if (!img) return;
    if (e.pointerType === "touch") {
      const now = Date.now();
      if (now - last > 320) {
        last = now;
        return;
      }
      last = 0;
    }
    img.classList.toggle("terrain-image-zoomed");
  });
  document.addEventListener("pointermove", (e) => {
    const media = e.target.closest(selector),
      img = media?.querySelector(".product-image");
    if (img?.classList.contains("terrain-image-zoomed")) {
      const r = media.getBoundingClientRect();
      img.style.transformOrigin = `${Math.max(0, Math.min(100, ((e.clientX - r.x) / r.width) * 100))}% ${Math.max(0, Math.min(100, ((e.clientY - r.y) / r.height) * 100))}%`;
    }
  });
  document.addEventListener("pointerout", (e) => {
    if (e.pointerType === "touch") return;
    const media = e.target.closest(selector);
    if (media && !media.contains(e.relatedTarget)) {
      const img = media.querySelector(".product-image");
      img?.classList.remove("terrain-image-zoomed");
      if (img) img.style.transformOrigin = "";
    }
  });
})();
(() => {
  const init = () => {
    document
      .querySelectorAll("[data-terrain-faq]:not([data-faq-ready])")
      .forEach((faq) => {
        faq.dataset.faqReady = "true";
        const info = faq.closest(".product-info"),
          description = info?.querySelector(
            '[data-dynamic-product-content$="-description-content"]',
          );
        if (!description) return;
        const questions = [...description.querySelectorAll("details")];
        const intro = questions[0]?.previousElementSibling;
        if (intro && /^H[23]$/.test(intro.tagName)) intro.remove();
        if (questions.length) {
          faq.replaceChildren();
          questions.forEach((d) => {
            d.classList.add("terrain-faq-question");
            d.open = false;
            faq.append(d);
          });
          description.querySelectorAll("h2,h3").forEach((h) => {
            if (/häufig(?:e| gestellte) fragen|faq/i.test(h.textContent))
              h.remove();
          });
        }
        description.querySelector("h2")?.setAttribute("hidden", "");
      });
    document.querySelectorAll(".terrain-specs").forEach((dl) => {
      const seen = new Set();
      dl.querySelectorAll(":scope>div").forEach((row) => {
        const label = row
          .querySelector("dt")
          ?.textContent.trim()
          .toLocaleLowerCase();
        if (seen.has(label)) row.remove();
        else seen.add(label);
      });
    });
  };
  new MutationObserver(init).observe(document.body, {
    childList: true,
    subtree: true,
  });
  init();
})();

document.addEventListener("change", (e) => {
  if (!e.target.matches(".card__swatches input")) return;
  const card = e.target.closest("product-card"),
    plus = card.querySelector(".terrain-card-plus");
  if (!plus) return;
  plus.dataset.selectedColor = e.target.value;
  if (plus.hasAttribute("data-terrain-direct")) {
    plus.dataset.terrainDirect = e.target.dataset.variantId;
    plus.disabled = e.target.dataset.available !== "true";
  } else {
    const url = new URL(plus.dataset.productUrl, location.origin);
    url.searchParams.set("variant", e.target.dataset.variantId);
    plus.dataset.productUrl = url.href;
  }
});

(() => {
  const init = () => {
    const p = new URLSearchParams(location.search),
      from = p.get("tf_from");
    if (!from || !/^[a-zA-Z0-9_-]+$/.test(from)) return;
    document.querySelectorAll("[data-finder-context]").forEach((el) => {
      const u = new URL("/pages/" + from, location.origin);
      for (const [k, v] of p)
        if (
          (k.startsWith("tf_") && k !== "tf_from" && k !== "tf_labels") ||
          k === "preview_theme_id" ||
          k === "view"
        )
          u.searchParams.set(k, v);
      el.querySelector("span").textContent =
        "Finder-Auswahl: " + (p.get("tf_labels") || "Deine Auswahl");
      el.querySelector("a").href = u.href;
      el.hidden = false;
    });
  };
  init();
  document.addEventListener("shopify:section:load", init);
})();

// Observe modal surfaces themselves, never every class mutation in the product grid.
(() => {
  const html = document.documentElement,
    header = document.querySelector(".cc-header"),
    menu = document.querySelector("main-menu"),
    overlay = document.querySelector(".js-overlay");
  const desktop = () => matchMedia("(min-width:769px)").matches;
  let mode = "",
    saved = 0,
    queued = false;
  const sync = () => {
    queued = false;
    const mobileMenu =
      !desktop() && menu?.mainContent.classList.contains("is-open");
    const modal =
      mobileMenu ||
      !!document.querySelector(
        "dialog[open],modal-dialog[open],cart-drawer[open],quick-add-drawer[open],predictive-search[open],store-header.search-is-visible",
      ) ||
      (!matchMedia("(min-width:1024px)").matches &&
        !!document.querySelector("facet-filters[open]"));
    const nav =
      desktop() && !!menu?.querySelector(".main-nav__item--dropdown.is-open");
    const next = modal ? "modal" : nav ? "menu" : "";
    html.classList.toggle("terrain-mobile-menu-open", !!mobileMenu);
    html.classList.toggle(
      "terrain-search-open",
      !desktop() &&
        !!document.querySelector(
          "store-header.search-is-visible,.cc-header predictive-search[open]",
        ),
    );
    if (modal) html.classList.remove("terrain-header-hidden");
    if (next === mode) return;
    const previous = mode;
    mode = next;
    if (previous !== "modal" && next === "modal") {
      saved = scrollY;
      html.style.setProperty(
        "--terrain-header-top",
        Math.max(0, header?.getBoundingClientRect().top || 0) + "px",
      );
      html.style.setProperty("--terrain-scroll", -saved + "px");
    }
    html.classList.toggle("terrain-menu-open", next === "menu");
    html.classList.toggle("terrain-modal-open", next === "modal");
    if (previous === "modal" && next !== "modal") {
      html.style.removeProperty("--terrain-scroll");
      scrollTo({ top: saved, behavior: "instant" });
    }
    if (mobileMenu && overlay && !overlay.classList.contains("is-visible"))
      overlay.classList.add("is-visible");
    if (
      previous === "modal" &&
      !next &&
      overlay &&
      !document.querySelector(".drawer[open]")
    )
      overlay.classList.remove("is-visible");
  };
  const schedule = () => {
    if (!queued) {
      queued = true;
      queueMicrotask(sync);
    }
  };
  const observed = new WeakSet();
  const observer = new MutationObserver(schedule);
  const bind = () => {
    document
      .querySelectorAll(
        "dialog,modal-dialog,.drawer,predictive-search,store-header,.main-menu__content,.main-nav>.main-nav__item--dropdown",
      )
      .forEach((e) => {
        if (observed.has(e)) return;
        observed.add(e);
        observer.observe(e, {
          attributes: true,
          attributeFilter: ["open", "class"],
        });
      });
    schedule();
  };
  if (header)
    new ResizeObserver(() => {
      const h = header.querySelector('[data-is-sticky="true"]')
        ? header.querySelector("store-header").getBoundingClientRect().height
        : 0;
      html.style.setProperty("--terrain-sticky-height", h + "px");
    }).observe(header);
  overlay?.addEventListener("click", () => {
    if (!desktop() && menu?.mainContent.classList.contains("is-open"))
      menu.handleClose();
  });
  document.addEventListener("terrain:surfaces-changed", bind);
  document.addEventListener("shopify:section:load", bind);
  document.addEventListener("on:quickbuy:after-open", bind);
  addEventListener("resize", schedule, { passive: true });
  bind();
})();

// Mobile scroll direction: keep results controls visible while the header retreats.
(() => {
  const html = document.documentElement;
  let anchor = scrollY,
    queued = false;
  const sync = () => {
    queued = false;
    const y = Math.max(0, scrollY);
    if (
      !matchMedia("(max-width:768px)").matches ||
      html.classList.contains("terrain-modal-open")
    ) {
      anchor = y;
      html.classList.remove("terrain-header-hidden");
      return;
    }
    if (y < 80) {
      html.classList.remove("terrain-header-hidden");
      anchor = y;
      return;
    }
    if (Math.abs(y - anchor) > 10) {
      html.classList.toggle("terrain-header-hidden", y > anchor);
      anchor = y;
    }
  };
  addEventListener(
    "scroll",
    () => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(sync);
      }
    },
    { passive: true },
  );
  addEventListener("resize", sync, { passive: true });
  const finder = () => {
    if (
      !matchMedia("(max-width:768px)").matches ||
      !new URLSearchParams(location.search).has("tf_from")
    )
      return;
    const results = document.getElementById("filter-results");
    if (!results) return;
    customElements.whenDefined("facet-filters").then(() => {
      document.querySelector("facet-filters")?.close();
      requestAnimationFrame(() => {
        const toolbar = document.querySelector("products-toolbar");
        (toolbar || results).scrollIntoView({
          block: "start",
          behavior: "instant",
        });
      });
    });
  };
  if (document.readyState === "complete") finder();
  else addEventListener("load", finder, { once: true });
})();

// Keep deeper mobile navigation inside the native menu and disclosure controls.
document.addEventListener("click", (event) => {
  const back = event.target.closest(".terrain-group-back");
  if (!back) return;
  const group = back.closest("details");
  group.classList.remove("terrain-group-open");
  group.querySelector("summary").focus();
});

// Focus inside the initiating tap, before Safari's keyboard activation expires.
document.addEventListener(
  "click",
  (event) => {
    const toggle = event.target.closest(".js-show-search,.js-show-search-left");
    if (!toggle || !matchMedia("(max-width:768px)").matches) return;
    const header = toggle.closest("store-header");
    const bar = header?.querySelector(".js-search-bar");
    const input = bar?.querySelector(".js-search-input");
    if (!input) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const opening = header.classList.contains("search-is-collapsed");
    toggle.setAttribute("aria-expanded", String(opening));
    toggle.setAttribute(
      "aria-label",
      opening ? "Suche schlie\u00dfen" : "Suchen",
    );
    if (opening) {
      header.terrainSearchScroll = document.documentElement.classList.contains(
        "terrain-modal-open",
      )
        ? -(
            parseFloat(
              document.documentElement.style.getPropertyValue(
                "--terrain-scroll",
              ),
            ) || 0
          )
        : window.scrollY;
      const menu = document.querySelector("main-menu");
      if (menu?.mainContent?.classList.contains("is-open")) {
        menu.closeMainMenu(false);
        menu.toggleOverlay(false);
        menu.childNavOpen = false;
      }
      header.classList.remove("search-is-collapsed");
      header.classList.add("search-is-visible");
      document.documentElement.classList.add("terrain-search-open");
      input.focus({ preventScroll: true });
      document.documentElement.style.setProperty(
        "--r24-search-bottom",
        bar.getBoundingClientRect().bottom + "px",
      );
    } else {
      header.querySelector("predictive-search")?.close();
      header.classList.remove("search-is-visible");
      header.classList.add("search-is-collapsed");
      document.documentElement.classList.remove("terrain-search-open");
      input.blur();
      const returnY = header.terrainSearchScroll;
      requestAnimationFrame(() => {
        if (
          !header.classList.contains("search-is-visible") &&
          Number.isFinite(returnY)
        ) {
          window.scrollTo({ top: returnY, behavior: "instant" });
        }
      });
    }
    window.setHeaderHeight?.();
    document.dispatchEvent(new Event("terrain:surfaces-changed"));
  },
  true,
);

// Theme-specific behaviour stays outside the unchanged Enterprise core.
document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  const modal = document.querySelector("modal-dialog[open]");
  if (modal && typeof modal.close === "function") {
    modal.close();
    return;
  }
  const menu = event.target.closest("main-menu");
  if (!menu) return;
  if (
    !matchMedia("(min-width:769px)").matches &&
    menu.mainContent?.classList.contains("is-open")
  ) {
    event.preventDefault();
    event.stopPropagation();
    const disclosure = menu.querySelector(".main-nav__item--dropdown.is-open");
    if (disclosure) menu.close(disclosure, false);
    menu.opener = menu.mainToggle;
    menu.closeMainMenu(false);
    menu.toggleOverlay(false);
    menu.childNavOpen = false;
  } else {
    const opener = menu.querySelector(
      ".main-nav__item--dropdown.is-open .main-nav__item--primary",
    );
    if (opener) setTimeout(() => opener.focus(), 0);
  }
});
document.addEventListener("change", (event) => {
  const input = event.target;
  if (!input.matches("product-card .opt-btn")) return;
  const card = input.closest("product-card"),
    form = card.querySelector(".terrain-card-direct");
  if (form) {
    form.elements.id.value = input.dataset.variantId;
    form.querySelector('[name="add"]').disabled =
      input.dataset.available !== "true";
  }
  card
    .querySelectorAll("[data-terrain-add-size]")
    .forEach(
      (button) => (button.hidden = button.dataset.color !== input.value),
    );
});
// Portals remove stacking-context clipping while preserving native modal controls.
const terrainPortal = () =>
  document.querySelectorAll("modal-dialog.terrain-drawer, modal-dialog#size-chart").forEach((dialog) => {
    if (dialog.parentElement !== document.body) document.body.append(dialog);
  });
terrainPortal();
document.addEventListener("shopify:section:load", terrainPortal);
// The native hide-on-scroll mode is unnecessary for the always-visible header setting.
customElements.whenDefined("store-header").then(() => {
  document
    .querySelectorAll('store-header[data-sticky-mode="always"]')
    .forEach((header) => {
      header.handleScroll = () => {};
    });
});

/* Desktop enhancements use native Shopify forms, menus and gallery controls. */
(() => {
  // Root scrollbar-gutter can shrink vw units while a drawer locks scrolling.
  const measureMenuWidth = () =>
    document.documentElement.style.setProperty(
      "--terrain-menu-width",
      innerWidth + "px",
    );
  measureMenuWidth();
  addEventListener("resize", measureMenuWidth, { passive: true });
  const desktop = matchMedia("(min-width:769px)");
  const toolbar = document.querySelector(".l products-toolbar"),
    header = document.querySelector(".cc-header");
  if (toolbar && header) {
    const html = document.documentElement;
    let anchor = scrollY,
      queued = false;
    const scrollState = () => {
      queued = false;
      if (!desktop.matches) return;
      if (
        html.classList.contains("terrain-modal-open") ||
        html.classList.contains("terrain-menu-open")
      ) {
        anchor = scrollY;
        return;
      }
      html.classList.toggle("terrain-compact", scrollY >= 80);
      const y = Math.max(0, scrollY),
        past = toolbar.getBoundingClientRect().top <= 1;
      if (!past || y < 80) {
        html.classList.remove(
          "terrain-filter-sticky",
          "terrain-header-visible",
        );
        anchor = y;
        return;
      }
      if (Math.abs(y - anchor) >= 12) {
        const down = y > anchor;
        html.classList.toggle("terrain-filter-sticky", down);
        html.classList.toggle("terrain-header-visible", !down);
        anchor = y;
      }
    };
    addEventListener(
      "scroll",
      () => {
        if (!queued) {
          queued = true;
          requestAnimationFrame(scrollState);
        }
      },
      { passive: true },
    );
    desktop.addEventListener("change", () => {
      if (!desktop.matches)
        html.classList.remove(
          "terrain-filter-sticky",
          "terrain-header-visible",
          "terrain-compact",
        );
    });
    scrollState();
  }
  document.addEventListener("click", (event) => {
    if (!desktop.matches) return;
    const summary = event.target.closest(".terrain-mega details>summary");
    if (summary && !event.target.closest("a")) {
      event.preventDefault();
      // Group headings are labels; their explicit category links handle navigation.
    }
  });

  // Never submit the previous size while Shopify is resolving a new selection.
  document.addEventListener(
    "change",
    (event) => {
      if (!desktop.matches || !event.target.closest("variant-picker")) return;
      const surface = event.target.closest("quick-add-drawer,.pdp");
      if (surface) {
        surface.dataset.desktopVariantPending = "true";
        surface.setAttribute("aria-busy", "true");
      }
    },
    true,
  );
  document.addEventListener("on:variant:change", (event) => {
    const surface = event.target.closest("quick-add-drawer,.pdp");
    if (surface) {
      delete surface.dataset.desktopVariantPending;
      surface.removeAttribute("aria-busy");
    }
  });
  document.addEventListener(
    "submit",
    (event) => {
      if (
        desktop.matches &&
        event.target.closest("[data-desktop-variant-pending]")
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );

  let drag;
  document.addEventListener("pointerdown", (event) => {
    if (!desktop.matches || event.button !== 0 || event.pointerType !== "mouse")
      return;
    const track = event.target.closest(".terrain-category-banner");
    if (
      !track ||
      event.target.closest("button") ||
      track.scrollWidth <= track.clientWidth + 1
    )
      return;
    drag = {
      track,
      x: event.clientX,
      y: event.clientY,
      left: track.scrollLeft,
      id: event.pointerId,
      moved: false,
    };
  });
  document.addEventListener("dragstart", (event) => {
    if (desktop.matches && event.target.closest(".terrain-category-banner"))
      event.preventDefault();
  });
  document.addEventListener(
    "pointermove",
    (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x;
      if (
        !drag.moved &&
        (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(event.clientY - drag.y))
      )
        return;
      drag.moved = true;
      drag.track.setPointerCapture(event.pointerId);
      drag.track.style.scrollSnapType = "none";
      drag.track.scrollLeft = drag.left - dx;
      event.preventDefault();
    },
    { passive: false },
  );
  const finish = () => {
    if (!drag) return;
    const { track, moved } = drag;
    drag = null;
    track.style.removeProperty("scroll-snap-type");
    if (moved) {
      track.dataset.desktopDragged = "true";
      setTimeout(() => delete track.dataset.desktopDragged, 400);
    }
  };
  document.addEventListener("pointerup", finish);
  document.addEventListener("pointercancel", finish);
  document.addEventListener(
    "click",
    (event) => {
      if (event.target.closest("[data-desktop-dragged]")) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );

  // Horizontal trackpad input belongs to the card image, not the page behind it.
  const wheelBound = new WeakSet();
  let wheelGesture = {
    last: -Infinity,
    step: -Infinity,
    delta: 0,
    axis: null,
    media: null,
    direction: 0,
  };
  const onWheel = (event) => {
    if (!desktop.matches || event.ctrlKey) return;
    const media = event.target.closest("product-card .card__media");
    if (!media || media.querySelectorAll("[data-terrain-picture]").length !== 2)
      return;
    const now = performance.now(),
      scale =
        event.deltaMode === 1
          ? 16
          : event.deltaMode === 2
            ? media.clientWidth
            : 1;
    const dx = event.deltaX * scale,
      dy = event.deltaY * scale,
      direction = Math.sign(dx);
    if (now - wheelGesture.last > 120 || wheelGesture.media !== media) {
      wheelGesture = {
        last: now,
        step: -Infinity,
        delta: 0,
        axis: null,
        media,
        direction,
      };
    }
    wheelGesture.last = now;
    if (!wheelGesture.axis)
      wheelGesture.axis =
        Math.abs(dx) > Math.abs(dy) * 1.5 ? "horizontal" : "vertical";
    if (wheelGesture.axis !== "horizontal") return;
    event.preventDefault();
    event.stopPropagation();
    if (
      direction &&
      direction !== wheelGesture.direction &&
      Math.abs(dx) >= 6
    ) {
      wheelGesture.delta = 0;
      wheelGesture.step = -Infinity;
      wheelGesture.direction = direction;
    }
    // Ignore the small inertial tail, but permit continued swipes without lifting the pointer.
    if (Math.abs(dx) < 6 || now - wheelGesture.step < 280) return;
    wheelGesture.delta += dx;
    if (Math.abs(wheelGesture.delta) >= 100) {
      media
        .querySelector(
          `[data-terrain-picture="${wheelGesture.delta > 0 ? 1 : -1}"]`,
        )
        .click();
      wheelGesture.delta = 0;
      wheelGesture.step = now;
    }
  };
  document.addEventListener(
    "pointerover",
    (event) => {
      if (!desktop.matches) return;
      const media = event.target.closest("product-card .card__media");
      if (!media || wheelBound.has(media)) return;
      media.addEventListener("wheel", onWheel, { passive: false });
      wheelBound.add(media);
    },
    { passive: true },
  );
})();

/* Bereich video controls, initialized only when its media exists. */
(() => {
  if (window.terrainBereicheLoaded) return;
  window.terrainBereicheLoaded = true;
  function init(root = document) {
    root.querySelectorAll('[data-tb-video]').forEach(video => {
      if (video.dataset.ready) return;
      video.dataset.ready = 'true';
      const button = video.parentElement.querySelector('[data-tb-video-toggle]');
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      button.hidden = false;
      const update = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; button.setAttribute('aria-label', button.textContent); };
      const play = () => {
        const source = video.querySelector('source');
        if (!source.src) { source.src = source.dataset.src; video.load(); }
        video.play().catch(update);
      };
      button.addEventListener('click', () => video.paused ? play() : video.pause());
      video.addEventListener('playing', () => { video.classList.add('is-playing'); update(); });
      video.addEventListener('pause', update);
      video.addEventListener('error', () => { video.classList.remove('is-playing'); button.hidden = true; });
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
      if (!navigator.connection?.saveData && matchMedia('(min-width: 769px)').matches) play();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


// Desktop groups are server-open; mobile drilldown changes only after a tap.
document.addEventListener("click", (event) => {
  const summary = event.target.closest(".terrain-mega details>summary");
  if (summary && matchMedia("(max-width:768px)").matches) {
    event.preventDefault();
    summary.parentElement.classList.toggle("terrain-group-open");
  }
  document.querySelectorAll(".terrain-language__details[open]").forEach(details => {
    if (!details.contains(event.target)) details.open = false;
  });
});
document.addEventListener("keydown", event => {
  if (event.key !== "Escape") return;
  document.querySelectorAll(".terrain-language__details[open]").forEach(details => {
    details.open = false;
    details.querySelector("summary").focus();
  });
});
